import styled from 'styled-components';

import theme from '@cld/theme-helper';
import { FieldSize } from '../FieldSize';

export interface DecorationWrapperProps {
  size: FieldSize;
}

export const DecorationWrapper = styled.div<DecorationWrapperProps>`
  align-items: center;
  display: flex;
  line-height: 1;

  &:first-child {
    padding-left: ${theme`spacing.xs`};
  }

  &:last-child {
    padding-right: ${theme`spacing.xs`};
  }
`;
